(function(){
  if(window.twAnimLoaded)return;window.twAnimLoaded=true;
  var root=document.documentElement;
  if(!('IntersectionObserver' in window))return;
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  root.classList.add('tw-js');
  var map=[
    ['.tw-head,.twc-head','up'],['.tw-card,.twc-card','up'],['.tw-tb__item','up'],
    ['.tw-finder__intro','l'],['.tw-finder__form','r'],
    ['.tw-guar__media','l'],['.tw-guar__list li','r'],
    ['.tw-steps li,.twc-psteps li','up'],['.twc-cmp__row','r'],
    ['.tw-faq details,.twc-faq details','up'],['.tw-rev','up'],['.twc-pcta','z'],
    ['.tw-cta__inner','z'],['.twc-pfaq__trust div','l'],
    ['.twc-benefits li','r'],['.twc-fitcheck','z'],['.twc-pbox__row','up']
  ];
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});
  },{threshold:0.12,rootMargin:'0px 0px -40px 0px'});
  function init(scope){
    map.forEach(function(m){
      scope.querySelectorAll(m[0]).forEach(function(el){
        if(el.classList.contains('tw-rv')||el.closest('.twc-desc'))return;
        var i=Array.prototype.indexOf.call(el.parentNode.children,el);
        el.style.setProperty('--tw-d',Math.min(i,6)*90+'ms');
        el.classList.add('tw-rv');
        if(m[1]!=='up')el.classList.add('tw-rv--'+m[1]);
        io.observe(el);
      });
    });
  }
  function start(){init(document);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  setTimeout(function(){
    document.querySelectorAll('.tw-rv:not(.is-in)').forEach(function(el){
      if(el.getBoundingClientRect().top<window.innerHeight)el.classList.add('is-in');
    });
  },2000);
})();